import NProgress from 'nprogress';
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getEmployeeId, getUserId } from "../../Base/helper/baseFunctions";

export const GetReadOnlyExitEmployeesHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getReadOnlyExitEmployee`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            login_employee_id: getEmployeeId(),
            view_usertype: params?.view_usertype, // 'Admin' / 'Manager
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null,
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit employees", hasError: true, data: err?.response?.data }
    });
};

export const GetPendingApprovalAdjustmentExitEmployeesHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getPendingApprovalAdjustmentExitEmployee`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            login_employee_id: getEmployeeId(),
            tab_type: params?.tab_type  // send "All" to get all records and 'Pending' to get only the ones which have atleast 1 approver_status No/null
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit employees", hasError: true, data: err?.response?.data }
    });
};

export const GetPendingApprovalClearanceExitEmployeesHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getPendingApprovalClearanceExitEmployee`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            login_employee_id: getEmployeeId(),
            tab_type: params?.tab_type  // send "All" to get all records and tab_type:'Pending' to get only the ones which have atleast 1 approver_status No/null
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit employees", hasError: true, data: err?.response?.data }
    });
};

export const GetExitCompletedEmployeesHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/employee/getExitCompletedEmployeeList`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            tab: params?.tab,  // regular/daily wages
            login_employee_id: getEmployeeId(),
            view_usertype: params?.view_usertype, // 'Admin' / 'Manager,
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null,
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Exit completed employees retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve exit completed employees", hasError: true, data: err?.response?.data }
    });
};